import { Row, Col } from "../../App.styles";

const Trivia = ({ useQuery }) => {
  const { trivia } = useQuery();

  return (
    <>
      <Row>
        <Col>
          <p>Complete by: Trivia</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>Answers (separate by commas): {trivia}</p>
        </Col>
      </Row>
    </>
  );
};

export default Trivia;
